import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectArchiveStatusFragment = { __typename?: 'Project', archivedAt?: string | null };

export const ProjectArchiveStatus = /*#__PURE__*/ gql`
    fragment ProjectArchiveStatus on Project {
  archivedAt
}
    ` as unknown as DocumentNode<ProjectArchiveStatusFragment, unknown>;

        

        
export const useProjectArchiveStatusFragment = (
  input: string | Omit<UseFragmentOptions<ProjectArchiveStatusFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectArchiveStatusFragment>({
    fragment: ProjectArchiveStatus,
    fragmentName: 'ProjectArchiveStatus',
    ...options,
  });
};
  
        